import React, { ReactNode } from 'react';
import { Statistic } from 'antd';
import { StatisticProps } from 'antd/lib/statistic/Statistic';
import { countdownValueType } from 'antd/lib/statistic/utils';

export interface CountdownProps extends StatisticProps {
  value?: countdownValueType;
  format?: string;
  children?: ReactNode;
  onFinish?: () => void;
}

const ProStatisticCountdown: React.FC<CountdownProps> = (props) => {
  const { children, ...resProps } = props;

  return <Statistic.Countdown {...resProps}>{children}</Statistic.Countdown>;
};

export default ProStatisticCountdown;
